import "./css/CheckBox.scss"
export default function CheckBox(props) {
    return (
        <label className="container">{props.text}
            <input type="checkbox" onChange={props.setCheck} checked={props.checked}/>
            <span className="checkmark"></span>
        </label>
    )
}